import { useEffect, useState } from 'react'
import { getCookie } from './cookie'


// 自定义 Hook：轮询监听 group，30 秒后停止
export function useGroupCookie(pollingInterval = 1000, maxDuration = 30000) {
  const [group, setGroup] = useState(() => getCookie('X-Service-Group-AB'))

  useEffect(() => {
    let lastValue = group
    const startTime = Date.now()

    const interval = setInterval(() => {
      const current = getCookie('X-Service-Group-AB')
      if (current !== lastValue) {
        lastValue = current
        setGroup(current)
      }

      // 如果轮询超过最大持续时间，停止轮询
      if (Date.now() - startTime >= maxDuration) {
        clearInterval(interval)
      }
    }, pollingInterval)

    return () => clearInterval(interval)
  }, [])

  return group
}
